export function locate(el, attr = "data-id") {
    let node = el;
    if (el.changedTouches) {
        const { clientX, clientY } = el.changedTouches[0];
        node = document.elementFromPoint(clientX, clientY);
    }
    else if (!el.tagName && el.target) {
        node = el.target;
    }
    while (node) {
        if (node.getAttribute) {
            const id = node.hasAttribute(attr);
            if (id)
                return node;
        }
        node = node.parentNode;
    }
    return null;
}
export function locateID(el, attr = "data-id") {
    const node = locate(el, attr);
    if (node) {
        return getID(node, attr);
    }
    return null;
}
export function getID(node, attr = "data-id") {
    let id = node.getAttribute(attr);
    const idType = node.getAttribute("data-id-type");
    const num = parseInt(id);
    if ((attr !== "data-resizer" && attr !== "data-id") ||
        idType === "number") {
        id = !Number.isNaN(num) && `${num}` === id ? num : id;
    }
    return id;
}
export function getNodeByAttr(id, node = document, attr = "data-id") {
    if (node !== document && node.getAttribute(attr) === id) {
        return node;
    }
    return node.querySelector(`[${attr}='${id}']`);
}
export function elementFromPosition(e, attr) {
    const elements = document.elementsFromPoint(e.clientX, e.clientY);
    let id = "";
    let node;
    for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (el.hasAttribute(attr)) {
            id = locateID(el, attr);
            node = locate(el, attr);
            break;
        }
    }
    return { node, id };
}
//# sourceMappingURL=locate.js.map